var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    fill: "#536DFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.854 17.353L18.708 11.499L17.479 10.27L12.854 14.895L10.542 12.582L9.312 13.811L12.854 17.353ZM6.5 21.499V6.49903H11.667C11.8337 5.99903 12.132 5.59636 12.562 5.29103C12.9927 4.98503 13.472 4.83203 14 4.83203C14.528 4.83203 15.0073 4.98503 15.438 5.29103C15.868 5.59636 16.1663 5.99903 16.333 6.49903H21.5V21.499H6.5ZM14 7.62403C14.1667 7.62403 14.3127 7.5617 14.438 7.43703C14.5627 7.3117 14.625 7.1657 14.625 6.99903C14.625 6.83236 14.5627 6.68636 14.438 6.56103C14.3127 6.43636 14.1667 6.37403 14 6.37403C13.8333 6.37403 13.6873 6.43636 13.562 6.56103C13.4373 6.68636 13.375 6.83236 13.375 6.99903C13.375 7.1657 13.4373 7.3117 13.562 7.43703C13.6873 7.5617 13.8333 7.62403 14 7.62403Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.8706152f02c59aee661fb07675cb0292.svg";
export { ForwardRef as ReactComponent };